<script setup lang="ts">
/**
 * 清單頁的「清除全部條件」（批186）——搭配 `lib/persistedFilters.ts`。
 *
 * ★ **永遠渲染、沒有條件時 disabled**，不要改成 `v-if`：選了條件才冒出來會把頁首其他控制項擠動
 *   （切換類控制項不可讓位置跳動）。`@click`／`size` 直接穿透到 UiButton。
 * ★ `type="button"`：UiButton 沒有預設 type，放進 form 會變成送出鈕。
 */
import UiButton from '@/components/UiButton.vue'

defineProps<{ dirty: boolean }>()
</script>

<template>
  <UiButton type="button" variant="ghost" :disabled="!dirty" title="清除這一頁的全部過濾條件">清除全部條件</UiButton>
</template>
